module.exports = require("vue-no-ssr");